import type { Filters } from '../FiltersContext';
import type { IEvent } from '../../';

export const canFilterByEventTags = (filters: Filters) => filters.selectedEventTags.length > 0;

export const filterByEventTags = (filters: Filters) => (event: IEvent) =>
	// Only return true for events that match at least one selected tag.
	// If no specific tag filtering is applied, return true to allow all events to pass.
	canFilterByEventTags(filters)
		? Array.isArray(event.tags) && event.tags.some((tag) => filters.selectedEventTags.includes(tag))
		: true;
